/**
 * ShimmerText
 *
 * Inline text rendered with the monochrome "thinking" shimmer sweep — use for
 * live status labels (e.g. "Thinking...", "Researching...") so the label itself
 * animates as the single liveness cue (no spinner). Renders a <span>; pass
 * layout classes (flex-1, truncate, sizing) via `className`.
 *
 * See shimmer.ts for the underlying class and animation mechanics.
 */
import type { ReactNode } from 'react';

import { SHIMMER_TEXT_CLASS } from './shimmer';

interface ShimmerTextProps {
  children: ReactNode;
  className?: string;
}

export function ShimmerText({ children, className = '' }: ShimmerTextProps) {
  return (
    <span className={`${SHIMMER_TEXT_CLASS} ${className}`}>{children}</span>
  );
}

export default ShimmerText;
